// extracted by mini-css-extract-plugin
export default {"deletedFileList":"RecycleBin_deletedFileList__rZ9DA","noFileMessage":"RecycleBin_noFileMessage__1ppwe"};